import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {ProductRecommendationDgSearchResults} from "../models/datagrid-search-results/product-recommendation.dg-search-results.model";
import {ProductRecommendationService} from "../providers/product-recommendation.service";

@Injectable()
export class ProductRecommendationResolve implements Resolve<ProductRecommendationDgSearchResults> {
  constructor(private productRecommendationService: ProductRecommendationService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<ProductRecommendationDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.productRecommendationService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
